'use client'
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalProps, cn } from "@heroui/react"
import { LightButton, DarkButton } from "../Button"
import { ReactNode } from "react"
import { useTranslations } from "next-intl"
import { mergeModalLayerClassNames, useModalLayer } from "@/ui/modalLayer"


export const Confirm = (
  { title, message, isLoading, onConfirm, footer, classNames, isOpen, ...props }:
    Omit<ModalProps, 'children' | 'title'> &
    {
      message: ReactNode,
      isLoading?: boolean,
      title: ReactNode,
      onConfirm?: () => void,
      footer?: ReactNode
    }
) => {

  const t = useTranslations()
  const layer = useModalLayer(isOpen)
  return (
    <Modal
      isOpen={isOpen}
      classNames={mergeModalLayerClassNames({
        ...classNames,
        base: cn("max-w-[360px] text-center", classNames?.base),
      }, layer)}
      {...props}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader
              className="block px-[16px] sm:px-[32px] pt-[28px] pb-[10px] justify-between text-[20px] text-theme-primary"
            >
              {title}
            </ModalHeader>
            <ModalBody
              className={cn(
                "px-[16px] sm:px-[32px] text-theme-primary/70 mt-[8px] text-[16px] max-h-[340px] overflow-y-auto",
                classNames?.body
              )}>
              {message}
            </ModalBody>
            <ModalFooter className={cn(
              "px-[16px] sm:px-[32px] pb-[32px] mt-[16px] justify-center gap-x-[16px] gap-y-3 flex-wrap",
              classNames?.footer
            )}>
              {
                footer ||
                <>
                  <LightButton className="w-[140px]" onPress={onClose}>{t('common.cancel')}</LightButton>
                  <DarkButton className="w-[140px]" isLoading={isLoading} onPress={onConfirm}>{t('common.confirm')}</DarkButton>
                </>
              }

            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}